/**
 * Token-provider selection by the build-time `NEXT_PUBLIC_AUTH_MODE` flag
 * (explicit, validated in env.ts — never inferred from config presence).
 */
import { AUTH_MODE } from "../env";
import { createFirebaseTokenProvider } from "./firebase";
import { createLocalTokenProvider } from "./local";
import type { TokenProvider } from "./token-provider";

let provider: TokenProvider | null = null;

/** The app-wide token provider singleton. */
export function getTokenProvider(): TokenProvider {
  provider ??=
    AUTH_MODE === "firebase" ? createFirebaseTokenProvider() : createLocalTokenProvider();
  return provider;
}

export type { LocalTokenProvider } from "./local";
export { LOADING_SNAPSHOT, type AuthSnapshot, type TokenProvider } from "./token-provider";
